// extracted by mini-css-extract-plugin
export default {"selectField":"SharingFields_selectField__22WzB","avatar":"SharingFields_avatar__WgAUq","manageUsersLink":"SharingFields_manageUsersLink__5sE+6"};